import React, { Component } from 'react'
import H3 from '../components/h3';
import { track } from '@amplitude/analytics-browser';

export default class TestMessage extends Component {

  componentDidMount(){
    const eventProperties = {
      test_id: this.props.tid,
      test_message: this.props.message,
    };
      track("test_message", eventProperties);
  };

  callbackToNative = (msg) => {
    try {
      if (window.webkit != undefined) {
        window.webkit.messageHandlers.observe.postMessage(msg);
        window.webkit.messageHandlers.appInterface.postMessage(msg);
      }
      if (window.appInterface != undefined) {
        window.appInterface.postMessage(msg);
      }
    } catch (error) {
      console.log(msg);
      console(error);
    }
  };

  render() {
    const callback = this.props.callback ? this.props.callback : "";
    console.log(callback);

    return (
      <div style={{ marginTop: "30px", textAlign: "center" }}>
        <div style={{ width: "50px", cursor: "pointer" }}>
          <img
            onClick={() => this.callbackToNative(callback)}
            src="/images/back.svg"
          ></img>
        </div>
        <div
          style={{
            height: "70vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <H3 style={{ textAlign: "center" }}>{this.props.message}</H3>
        </div>
      </div>
    );
  }
}
